(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('CmsEditHelpfulResourceController', CmsEditHelpfulResourceController);

  /* ngInject */
  function CmsEditHelpfulResourceController($state, $stateParams, Flash, categoryService, cmsBucketService, cmsHelpfulResourceService, formErrorsService, publishedStatuses, sessionService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.activate = activate;
    vm.bucketTitle = null;
    vm.buckets = [];
    vm.categories = [];
    vm.createBucket = createBucket;
    vm.deleteHelpfulResource = deleteHelpfulResource;
    vm.getHelpfulResource = getHelpfulResource;
    vm.getCategories = getCategories;
    vm.helpfulResource = {};
    vm.publishedStatuses = publishedStatuses;
    vm.saveTopics = saveTopics;
    vm.updateHelpfulResource = updateHelpfulResource;

    vm.activate();

    function activate() {
      getBuckets();
      getCategories();
      getHelpfulResource();
    }

    function deleteHelpfulResource() {
      angular.element('#deleteHelpfulResourceModal').modal('hide');
      cmsHelpfulResourceService(sessionService.getAuthToken()).delete({id: $stateParams.id}, _deleteHelpfulResourceSuccess, _deleteHelpfulResourceFailure);
    }

    function createBucket() {
      let bucket = {
        title: vm.bucketTitle,
        resource_type: 'helpful_resource'
      };

      cmsBucketService(sessionService.getAuthToken()).save(bucket, response => {
        vm.buckets.push(response);
        vm.helpfulResource.bucket_id = response.id;
        vm.bucketTitle = null;
        Flash.create('success', 'Bucket successfully created.');
      }, error => {
        Flash.create('danger', 'An error occurred with the submission. Please correct the errors below and resubmit.');
        vm.setFormErrors(vm.helpfulResourceForm, error);
      });
    }

    function getBuckets() {
      cmsBucketService(sessionService.getAuthToken()).query({ resource_type: 'helpful_resource' }, response => vm.buckets = response);
    }

    function getHelpfulResource() {
      cmsHelpfulResourceService(sessionService.getAuthToken()).get({ id: $stateParams.id }, response => {
        vm.helpfulResource = response;
        if (response.bucket) {
          vm.helpfulResource.bucket_id = response.bucket.id;
        }
      });
    }

    function getCategories() {
      categoryService(sessionService.getAuthToken()).query({include: 'topics'}, response => {vm.categories = response;});
    }

    function saveTopics() {
      cmsHelpfulResourceService(sessionService.getAuthToken()).saveTopics({id: vm.helpfulResource.id}, {topic_ids: vm.helpfulResource.topic_ids}, _response => {
        Flash.create('success', 'Topics successfully updated.');
      });
    }

    function updateHelpfulResource() {
      cmsHelpfulResourceService(sessionService.getAuthToken()).update(
        {id: vm.helpfulResource.id},
        vm.helpfulResource,
        _updateHelpfulResourceSuccess,
        _updateHelpfulResourceFailure
      );
    }

    function _deleteHelpfulResourceFailure(_response) {
      Flash.create('danger', 'An error occurred deleting the helpful resource. Please try again later.');
    }

    function _deleteHelpfulResourceSuccess(_response) {
      $state.go('application.compliance_services.cms_list_helpful_resources');
      Flash.create('success', 'The helpful resource was successfully deleted.');
    }

    function _updateHelpfulResourceSuccess(response) {
      Flash.create('success', `${response.title} was successfully updated.`);
    }

    function _updateHelpfulResourceFailure(response) {
      Flash.create('danger', 'An error occurred with the submission. Please correct the errors below and resubmit.');
      vm.setFormErrors(vm.helpfulResourceForm, response);
    }
  }
})();
